<template>
  <div
    class="bpm-global-loader position-fixed top-0 start-0 w-100 h-100 d-flex align-items-center justify-content-center bg-dark bg-opacity-50"
  >
    <div class="bpm-global-loader__card bg-white rounded shadow text-center p-5 mx-3">
      <div class="spinner-border text-primary mb-3"/>
      <p class="fw-bold fs-4 mb-2">{{ message }}</p>
      <p class="fs-5 text-muted mb-0">Не закрывайте и не обновляйте страницу</p>
    </div>
  </div>
</template>

<script>
export default {
  name: 'BpmOgpoGlobalLoader',
  props: {
    message: {
      type: String,
      default: 'Начало оформления полиса',
    },
  },
}
</script>

<style scoped>
.bpm-global-loader {
  z-index: 9998;
}

.bpm-global-loader__card {
  width: 60%;
}
</style>
